// extracted by mini-css-extract-plugin
export default {"header":"modalSkeleton_header__dyETM","footer":"modalSkeleton_footer__YsFFD","body":"modalSkeleton_body__ox3KX","iconBox":"modalSkeleton_iconBox__xFMq6"};